import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import store from "./stores/store";
import ApiWsEvents from "./constants/ApiWSEvents";
import connection, {mapWsEventsToActions} from "./services/hub/Connection";
import {handleWsRollingPrizeChanged} from "./stores/pickX/handlers/rollingPrizeHandlers";
connection.reduxDispatch = store.dispatch;
mapWsEventsToActions(ApiWsEvents.Accounts);
mapWsEventsToActions(ApiWsEvents.Sports);
mapWsEventsToActions(ApiWsEvents.PickX);
mapWsEventsToActions(ApiWsEvents.ECommerce);

connection.on("rollingPrizeChanged", (payload) => handleWsRollingPrizeChanged(store.dispatch, payload));
connection.connect();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
